import React from "react";
import cx from "classnames";
import dateformat from "dateformat";
import _ from "lodash";
import { TableCellText } from "./TableCellText";
import { renderInitials } from "../utils/format";
import styles from "./common.module.scss";

interface VisitorProfileCellProps {
  data: any;
  type?: "sessions" | "leads";
  showProfile?: boolean;
  // eslint-disable-next-line no-unused-vars
  onSelect?: (data: any) => void;
}

export const VisitorProfileCell: React.FC<VisitorProfileCellProps> = ({
  data,
  type = "leads",
  showProfile,
  onSelect,
}) => {
  const person = type === "sessions" ? data.visitor : data.contact;
  const name =
    type === "sessions"
      ? `${_.get(person, "firstName") || "-"} ${_.get(person, "lastName") || ""}`
      : `${_.get(person, "firstName") || "-"}`;
  const email = _.get(person, "email") as string | undefined;
  const lastVisited = data.lastVisited
    ? dateformat(data.lastVisited, "dd mmm yyyy")
    : "";

  const handleClick = () => {
    if (showProfile && onSelect) onSelect(data);
  };

  return (
    <div
      className={cx(styles.visitorCell, { [styles.clickable]: showProfile })}
      onClick={handleClick}
    >
      <div className={styles.avatar}>{renderInitials(person)}</div>
      <div className={styles.visitorInfo}>
        <TableCellText className={styles.visitorName} text={name} />
        {type === "sessions" && (
          <>
            {email && <TableCellText className={styles.visitorDate} text={email} />}
            {lastVisited && <TableCellText className={styles.visitorDate} text={lastVisited} />}
          </>
        )}
      </div>
    </div>
  );
};
